<mat-card class="billboard-card" appearance="outlined">
  <div class="billboard-header">
    <div class="billboard-header-main">
      @if (billboardChartInfo.iconName) {
        <mat-icon class="billboard-icon" color="primary">{{ billboardChartInfo.iconName }}</mat-icon>
      }
      <span class="billboard-title">{{ billboardChartInfo.title }}</span>
    </div>
    @if (billboardChartInfo.delta !== undefined && billboardChartInfo.delta !== null) {
      <span class="billboard-trend-badge" [ngClass]="{'positive': billboardChartInfo.delta >= 0, 'negative': billboardChartInfo.delta < 0}">
        <mat-icon>{{ billboardChartInfo.delta >= 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
        <span>{{ billboardChartInfo.delta | percent }}</span>
      </span>
    }
  </div>

  <div class="billboard-main-stat-area">
    <div class="billboard-main-stat-block">
      <span class="billboard-main-stat">{{ billboardChartInfo.graphRange?.value }}</span>
    </div>
    <div class="billboard-chart-area">
      @if (billboardChartInfo.datasets && billboardChartInfo.datasets[0]?.data?.length > 0) {
        <canvas
          baseChart
          class="billboard-chart"
          [type]="billboardChartInfo.type"
          [legend]="false"
          [datasets]="billboardChartInfo.datasets"
          [labels]="billboardChartInfo.labels"
          [options]="billboardChartInfo.options">
        </canvas>
      } @else {
        <div class="billboard-chart-placeholder">
          <mat-icon color="disabled">show_chart</mat-icon>
          <span>No Data</span>
        </div>
      }
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="billboard-highlights-list">
    @for (idx of [0,1,2,3]; track idx) {
      <div class="billboard-highlight-row">
        <span class="billboard-highlight-label">
          {{ billboardChartInfo.highlights[idx]?.label || '' }}
        </span>
        <span class="billboard-highlight-value">
          {{ (billboardChartInfo.highlights[idx]?.value != null && billboardChartInfo.highlights[idx]?.value !== '') ? billboardChartInfo.highlights[idx]?.value : '—' }}
        </span>
      </div>
    }
  </div>

  <mat-divider></mat-divider>

  <div class="billboard-footer">
    <span class="billboard-footer-label">{{ billboardChartInfo.footer?.label }}</span>
    <span class="billboard-footer-value">{{ billboardChartInfo.footer?.value }}</span>
  </div>
</mat-card>
